module.exports = __webpack_public_path__ + "static/img/button10.fb0e989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button10.png
// module id = Doxh
// module chunks = 4